import "./resultGrids.css";

/**
 * Class for a result-form grid that shows NO alternate-row (zebra) colour
 * (user request 2026-09-30). Pass it as `<AppDataGrid className={RESULT_GRID_NO_ZEBRA}>`
 * on the Result Entry Express, Result Tracking, Result Validation and Result
 * Approval grids — including their pending Job / QC Batch selection grids.
 * Importing this module also loads the rule (resultGrids.css), so a grid can
 * never carry the class without its style. The shared AppDataGrid is unchanged,
 * so every other form keeps its zebra.
 */
export const RESULT_GRID_NO_ZEBRA = "re-nozebra";
